// AWS Cognito Configuration
export const cognitoConfig = {
  region: "us-east-2",
  userPoolId: "us-east-2_6XtebAZuV",
  // clientId: "5kbeccutlf6vth15hbkvb1pffk"
  clientId: "69q6ho0ctr4aig4hl392sq5rku",
};

const resolvedApiBaseUrl =
  import.meta.env.VITE_API_GATEWAY_URL || import.meta.env.VITE_API_BASE_URL;

if (!resolvedApiBaseUrl) {
  // Fail loudly instead of silently defaulting to a hardcoded API host.
  // This module is imported at bundle-load time in the browser, so a bare
  // `throw` here would white-screen the entire app before any error UI
  // could render. Instead: log an unmissable error and set a baseUrl that
  // can never be mistaken for a working endpoint, so any request made
  // against it fails immediately and visibly (invalid URL / network error)
  // instead of silently talking to the stale `canvas-api-enhanced` stack --
  // an old REST API v1 generation (last updated 2025-10-09) with none of
  // Phase 1's security fixes: no KMS token encryption, no origin-restricted
  // CORS, no per-stage DynamoDB isolation. See docs/IMPLEMENTATION_PLAN.md
  // task 2.7.
  // eslint-disable-next-line no-console
  console.error(
    "[awsConfig] Neither VITE_API_GATEWAY_URL nor VITE_API_BASE_URL " +
      "is set. Refusing to fall back to a hardcoded API host -- fix the build " +
      "environment (see UI/.env.development / UI/.env.production)."
  );
}

// Enhanced API Configuration with performance settings
export const apiConfig = {
  baseUrl: resolvedApiBaseUrl || "MISCONFIGURED_API_BASE_URL",

  // Performance and caching settings
  caching: {
    enabled: import.meta.env.PROD,
    defaultTTL: 5 * 60 * 1000, // 5 minutes
    policies: {
      courses: { ttl: 15 * 60 * 1000 },    // 15 minutes
      grades: { ttl: 5 * 60 * 1000 },      // 5 minutes
      assignments: { ttl: 10 * 60 * 1000 }, // 10 minutes
      credentials: { ttl: 60 * 60 * 1000 }  // 1 hour
    }
  },
  
  // Request settings
  timeout: 30000, // 30 seconds
  retryCount: 3,
  retryDelay: 1000,
  
  // Batch processing settings
  batchSize: {
    courses: 10,
    assignments: 5,
    grades: 8
  }
};

// Canvas LMS Configuration
export const canvasConfig = {
  // Optional default Canvas instance URL. Intentionally has no hard-coded
  // school fallback: the user must pick their own instance.
  defaultRootUrl: import.meta.env.VITE_CANVAS_ROOT_URL || "",

  // API version
  apiVersion: "v1",

  // Default per_page value for pagination
  defaultPerPage: 100
};
